
<div class="modal active">
  <div class="modal__container modal__container--lg">
    <div class="fields">
      <h2>Contextual Help Settings</h2>
      <div class="close" (click)="bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="contextualHelpFrom" #ngForm="ngForm" id="contextualHelpFrom" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="table-fields">
                <div style="max-height: 350px; overflow-y: scroll;">
                  <table>
                    <thead>
                      <tr>
                        <th scope="col">Functionality</th>
                        <th scope="col">Description</th>
                        <th scope="col">Link</th>
                        <th scope="col">Link Name</th>
                        <th scope="col">Enabled</th>
                        <th scope="col">Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr mdbTableCol *ngFor="let data of this.contextualHelpService.contextualHelpToolTips; let i = index"
                      >
                        <td>{{ data.functionality }}</td>
                        <td>{{ data.descriptionText}}</td>
                        <td>{{ data.linkName}}</td>
                        <td>{{ data.link}}</td>
                        <td>{{data.isEnabled?"TRUE":"FALSE"}}</td>
                        <td>
                          <div class="btn flex-justify-center">
                            <a class="mr-0" (click)="edit(i)">Edit</a>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button (click)="bsModalRef.hide()" type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid">
              Ok
            </button>
          </div>
        </form>

      </div>
    </div>
  </div>
</div>
